import { render, staticRenderFns } from "./TargetedOffered.vue?vue&type=template&id=5a2e64c6&scoped=true&"
import script from "./TargetedOffered.vue?vue&type=script&lang=js&"
export * from "./TargetedOffered.vue?vue&type=script&lang=js&"
import style0 from "./TargetedOffered.vue?vue&type=style&index=0&id=5a2e64c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e64c6",
  null
  
)

export default component.exports